export default class TimeRange {
  hours: number;
  hoursStart: number;
  hoursEnd: number;

  constructor(startHours = -4, endHours = 8) {
    const hours = endHours - startHours;

    this.hours = hours;
    this.hoursStart = startHours;
    this.hoursEnd = endHours;
  }

  get timeStart() {
    const now = this.getRoundedNowTime();
    const time = new Date();
    time.setTime(now.getTime() + this.hoursStart * 60 * 60 * 1000);
    return time;
  }

  get timeEnd() {
    const now = this.getRoundedNowTime();
    const time = new Date();
    time.setTime(now.getTime() + this.hoursEnd * 60 * 60 * 1000);
    return time;
  }

  private getRoundedNowTime(round = 10): Date {
    const now = new Date();
    const minutes = now.getMinutes();

    now.setSeconds(0, 0);
    now.setMinutes(Math.round(minutes / round) * round);
    return now;
  }

  public toParamsObject() {
    return {
      time_start: this.timeStart.toISOString(),
      time_end: this.timeEnd.toISOString(),
    };
  }
}
